import layout from '@/layout'

export default {
  path: '/pre_close_in',
  component: layout,
  redirect: '/pre_close_in/page1',
  name: 'pre_close_in_page1',
  meta: {
    title: 'pre_close_in',
    icon: 'el-icon-d-arrow-right'
  },
  children: [
    {
      path: '/pre_close_in/page1',
      name: 'pre_close_in_page1',
      component: () => import('@/views/pre_settle/pre_close/in/index1'),
      meta: {
        title: 'pre_close_in_page1',
        icon: 'el-icon-d-arrow-right'
      }
    }
  ]
}
